/**
 * App shell version. Default v1 — set REACT_APP_APP_VERSION=2 when v2 ships.
 *
 * V1 gates: account menu (logout only), editor AI tools
 * (expand/upscale), image bg upload + stock search, before/after compare, reflection toggle, More menu,
 * download full-resolution export, Activity nav, Buy More Credits, Invite & Earn,
 * claim popup credits balance bar + 30-day terms line.
 */
export const IS_APP_V1 =
  (process.env.REACT_APP_APP_VERSION || "2").trim() === "1";

/** TEMP: set false again after mocking Buy More Credits in v1. */
export const SHOW_BUY_MORE_CREDITS = true;

/** Left nav Tools link. Set true to show it again. Dashboard tool rows stay visible either way. */
export const SHOW_TOOLS_NAV = false;
